<template>
    <div class="mr-auto ml-auto" style="margin-top: 100px; padding-left: 10rem; padding-right: 10rem" >
        <div class="d-flex align-items-center">
            <div style="flex-basis: 50%;" class="">
                <h1 class="fs-50">Please wait!</h1>
                <p class="fs-24 text-muted">We are taking you to somewhere really cool</p>
            </div>
            <div style="flex-basis: 50%;" class="text-center">
                <img style="width: 500px; height: 500px; object-fit: contain" src="/homepage/images/seamless-hiring-desktop.png" alt="SeamlessHiring Screenshot" />
            </div>
        </div>
       
        <div class="mt-5 mr-auto ml-auto" style="width: 50%">
            <sfe-progress v-model="progress"/>
        </div>
    </div>
</template>

<script>
    import AdminModel from '../../../models/AdminModel';
    import Auth from '../../../mixins/auth';
    import { eventBus } from '../../../models/AdminModel';

    export default {
        name: 'IdmsAuth',
        data() {
            return {
                progress: 0,
                adminToken: ''
            }
        },
        props: {
            idmsCode: {
                type: String,
            }
        },
        mixins: [AdminModel, Auth],
        mounted() {
            eventBus.$on('idms-login', (evt) => {
                const total = evt.total
                const current = evt.loaded
                this.progress = Math.floor((current / total) * 100)  
            })
        },
        methods: {
            handleIDMSAdminLogin(idmsCode) {
                const payload = {
                    code: idmsCode
                }
                this.AdminModel.IDMSLogin(payload)
                    .then((r) => {
                        const token = r?.data
                        this.adminToken = token
                    })
            },
            setUserAndRedirectToDashboard(token) {
                this.AuthMixin().extractPermissionsAndSetLoggedInUserFromAdminToken({ token })
                location.href=`${location.origin}${'/admin/advanced#/dashboard?login=true'}`
            }
        },
        watch: {
            idmsCode: {
                handler(newValue) {
                    if (newValue) {
                        this.handleIDMSAdminLogin(newValue)
                    }
                },
                immediate: true
            },
            'adminToken': {
                handler(newValue) {
                    this.setUserAndRedirectToDashboard(newValue)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>